module.exports = __webpack_public_path__ + "img/varilux-digitimes.cfb25fca.svg";